import { useState } from 'react'
import { useParams } from 'react-router-dom'
import './Clients.scss'
import FilterButtonsGroup from '../FilterButtonsGroup/FilterButtonsGroup'
import ClientCard from './ClientCard/ClientCard'
import Dropdown from '../Dropdown/Dropdown'
import {
  projectAphaSort,
  projectAscSort,
  projectDscSort
} from './filterProjects'

const Clients = ({ clientData }) => {
  const { slug } = useParams()

  const [filteredData, setFilteredData] = useState(null)

  const handleOnSelect = (selectedOption) => {
    if (selectedOption.id === 'sortby-alpha') {
      setFilteredData(projectAphaSort([...clientData]))
      return
    }
    if (selectedOption.id === 'sortby-ascending') {
      setFilteredData(projectAscSort([...clientData]))
      return
    }
    if (selectedOption.id === 'sortby-descending') {
      setFilteredData(projectDscSort([...clientData]))
      return
    }
  }

  const clients =
    filteredData && filteredData != null ? filteredData : clientData

  const rows = clients.reduce(
    (acc, _, i, clients) => (i % 2 ? acc : [...acc, clients.slice(i, i + 2)]),
    []
  )

  return (
    <>
      <div className="client-filters">
        <FilterButtonsGroup
          selectedLinkIndex={slug === 'current-clients' ? 0 : 1}
          links={[
            {
              url: '/current-clients',
              label: 'CURRENT'
            },
            {
              url: '/past-clients',
              label: 'PAST'
            }
          ]}
        />
      </div>
      <div className="client-sort">
        <Dropdown
          options={[
            {
              text: 'Alphabetical',
              id: 'sortby-alpha'
            },
            {
              text: 'Number of Projects (Ascending)',
              id: 'sortby-ascending'
            },
            {
              text: 'Number of Projects (Decending)',
              id: 'sortby-descending'
            }
          ]}
          placeholder="Sort by"
          id="sort-by-button"
          onSelect={handleOnSelect}
        />
      </div>
      <div className="client-container">
        {clients &&
          rows.map((row, index) => (
            <div key={index} className="client-row">
              {row.map((client, i) => (
                <ClientCard client={client} key={i} />
              ))}
              {row.length === 1 && <div className="client-card-placeholder" />}
            </div>
          ))}
      </div>
    </>
  )
}
export default Clients
